/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable global-require */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { BarcodeOutlined } from '@ant-design/icons';
import {
  Modal,
  Card,
  Col,
  Row,
  Spin,
} from 'antd';
import {
  Title, Button, Text,
} from 'components';

import generateReferenceBank from 'api/referenciasDeBanco';
import { printReferenceOrder } from 'api/recaudacion';
import Previewer from 'components/Previewer';
import _logger from 'utils/logger';
import { Container } from 'components/Steps';

/* eslint-disable import/no-dynamic-require */
const ENV_NAME = process.env.REACT_APP_ENV_NAME;

const bancos = [
  {
    id: 2,
    name: 'Multipagos BBVA',
    banco: 'bbva',
    referencia: generateReferenceBank,
    instrucciones: 'AQUI LAS INSTRCCIONES DE BBVA',
    descripcion: 'Bancomer',
    title: 'Exclusivo BBVA',
  },
  {
    id: 3,
    name: 'Micrositio de Pagos',
    banco: 'santander',
    referencia: generateReferenceBank,
    instrucciones: 'AQUI LAS INSTRCCIONES DE SANTANDER',
    descripcion: 'Santander',
    title: 'Exclusivo Santander',
  },
  {
    id: 4,
    name: 'Otros bancos',
    banco: 'otros',
    referencia: generateReferenceBank,
    instrucciones: 'AQUI LAS INSTRCCIONES',
    descripcion: 'BANCO SANTANDER',
    title: 'Exclusivo Otros Bancos',
  },
];

// Components
const CustomCard = ({
  name,
  banco,
  urlBanco,
  descripcion,
  title,
  showDialog,
  selectedBanco,
}) => {
  const logo = require(`../../../../public/${ENV_NAME}/bancos/${banco}.png`);
  return (
    <Col key={name} span={8} style={{ display: 'flex', justifyContent: 'center' }}>
      <Card
        key={name}
        hoverable
        onClick={() => {
          if (banco === 'bbva') {
            showDialog({
              name,
              banco,
              urlBanco,
              descripcion,
            });
            return;
          }
          selectedBanco(banco, urlBanco, descripcion);
        }}
        style={{
          width: 250,
          margin: 10,
          height: 190,
          display: 'flex',
          justifyContent: 'center',
          boxShadow: '2px 4px 8px 2px rgba(0,0,0,0.4)',
          borderRadius: 8,
        }}
      >
        <Container style={{ padding: 0 }}>
          <Text style={{
            fontWeight: '600',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 16,
            textAlign: 'center',
          }}
          >
            { title }
          </Text>
          <img
            alt={`banco-${name}`}
            src={logo}
            style={{
              width: '190px',
              padding: 20,
              marginTop: 20,
            }}
          />
        </Container>
      </Card>
    </Col>
  );
};

const ModalBancos = ({
  visible,
  onCancel,
  cargosGenerados,
  padron,
  tipoDePadron,
  padrones,
  currentClassifier,
  cbReferenciaBanco,
  isNewFolio,
  totalProp,
  periodoFiscal,
  folio,
}) => {
  const formRef = useRef();
  const [url, setUrl] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [previewBase64, setPreviewBase64] = useState();
  const [visibleInstrucciones, setVisibleInstrucciones] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (url) {
      setTimeout(() => {
        formRef.current.submit();
      }, 500);
    }
  }, [url]);

  // Functions
  const showOrder = async () => {
    try {
      setLoading(true);
      if (isNewFolio) {
        const request = await cbReferenciaBanco();
        if (request) {
          const values = {
            folio: request.folio_banco,
            entidad: 1,
            referencia_normal: false,
            base64: request.data,
          };
          const order = await printReferenceOrder(values);
          if (order) {
            setPreviewBase64(values.base64 || order?.data);
            setVisiblePreview(true);
          }
        }
      } else {
        setVisiblePreview(true);
      }
    } catch (error) {
      _logger(error);
    } finally {
      setLoading(false);
    }
  };

  const selectedBanco = async (banco, urlBanco, descripcion) => {
    try {
      setLoading(true);
      if (banco === 'otros') {
        setVisibleInstrucciones(true);
        return;
      }
      const result = await urlBanco[banco](
        tipoDePadron,
        padron,
        cargosGenerados,
        padrones,
        currentClassifier,
        descripcion,
        totalProp,
        periodoFiscal,
        folio,
      );
      if (result) setUrl(result);
    } catch (error) {
      _logger(error);
    } finally {
      setLoading(false);
    }
  };

  const showDialog = (values) => {
    Modal.info({
      title: 'Bancomer BBVA',
      footer: null,
      content: (
        <div>
          <Text>
            Favor de seleccionar la opcion de cheque en línea para poder procesar
            correctamente su pago.
          </Text>
        </div>
      ),
      onOk() {
        selectedBanco(values.banco, values.urlBanco, values.descripcion);
      },
    });
  };

  const stepsIntructions = (step, textStep) => (
    <Row gutter={15}>
      <Col sm={24} md={24}>
        <Text style={{ fontSize: 22, fontWeight: 'bold' }} $accent>{step}</Text>
        <Text style={{ fontSize: 18, fontWeight: 'bold', marginLeft: '15px' }}>{textStep}</Text>
      </Col>
    </Row>
  );
  return (
    <>
      <Modal
        style={{ top: 20 }}
        width={1200}
        visible={visible}
        onCancel={() => onCancel()}
        footer={null}
      >
        <Spin spinning={loading} tip="Cargando...">
          <Row gutter={[10, 15]} justify="center">
            <Title level={4} $accent style={{ fontWeight: 'bold' }}>
              SERVICIO DE PAGO CON TRANSFERENCIA BANCARIA
            </Title>
            <Col span={24}>
              <Title level={4} style={{ fontSize: 16, textAlign: 'center' }}>
                REALIZAR TU TRANSFERENCIA BANCARIA DE ACUERDO A LOS SIGUIENTES BANCOS
              </Title>
            </Col>
            <Col span={24} style={{ marginTop: 30 }}>
              <Row gutter={[10, 10]} justify="center">
                {bancos.map((banco) => (
                  <CustomCard
                    key={banco.name}
                    name={banco.name}
                    banco={banco.banco}
                    urlBanco={banco.referencia}
                    descripcion={banco.descripcion}
                    title={banco.title}
                    showDialog={showDialog}
                    selectedBanco={selectedBanco}
                  />
                ))}
              </Row>
            </Col>
          </Row>
          <br />
        </Spin>
      </Modal>
      <Previewer
        visible={visiblePreview}
        base64={previewBase64}
        isPDF
        onCancel={() => setVisiblePreview(false)}
      />
      <Modal
        visible={visibleInstrucciones}
        footer={null}
        onCancel={() => setVisibleInstrucciones(false)}
        style={{ top: 20 }}
        width="60%"
      >
        <Spin spinning={loading} tip="Cargando...">
          <Title level={4} style={{ fontSize: 20 }} strong>INTRUCCIONES</Title>
          <br />
          <Row gutter={[10, 15]}>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              style={{
                padding: '20px',
                backgroundColor: '#fff',
                borderRadius: '8px',
              }}
            >
              {stepsIntructions(1, 'Solo aplica para bancos distintos de BBVA y Santander, si eres usuario de estos bancos regresa al punto anterior y salecciona el icono de tu banca.')}
              {stepsIntructions(2, 'Ingresa a tu banca en línea.')}
              {stepsIntructions(3, 'Por primera vez, realice la alta del beneficiario, de lo contrario, seleccione la clave interbancaria correspondiente.')}
              {stepsIntructions(4, 'Realiza tu transferencia interbancaria con los siguientes datos:')}
              <br />
              <Text style={{ fontSize: 18, fontWeight: 'bold', display: 'inline-block' }}>Banco destino: BBVA</Text>
              <br />
              <Text strong>Pasos a seguir para generar su pago interbancario</Text>
              <br />
              <br />
              <Text strong>1.- Dar click en generar orden de transferencia interbacaria</Text>
              <br />
              <br />
              <Text strong>
                2.- A continuación, aparecera en la parte inferior del formato el
                logotipo de BBVA donde viene la clabe interbancaria de 18 dígitos y abajo
                la referencia de 20 dígitos con los cuales podra realizar su pago en cualquier
                banco.
              </Text>
              <br />
              <br />
              <Text strong>
                3.- Imprima o descargue el formato de pago interbancario.
              </Text>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12}>
              <div style={{
                padding: '20px', backgroundColor: '#681B2D', borderRadius: '8px', border: '1px solid #fff', height: '100%',
              }}
              >
                <Text style={{ fontSize: 20, fontWeight: 'bold', color: '#fff' }}>Información para la alta del beneficiario</Text>
                <br />
                <br />
                <Text strong style={{ color: '#fff' }}>Nombre</Text>
                <br />
                <Text style={{ color: '#fff' }}>SECRETARíA DE ADMINISTRACIÓN Y FINANZAS.</Text>
                <br />
                <br />
                <Text strong style={{ color: '#fff' }}>RFC</Text>
                <br />
                <Text style={{ color: '#fff' }}>SADO91223KK7</Text>
                <br />
                <br />
                <Text strong style={{ color: '#fff' }}>Teléfono</Text>
                <br />
                <Text style={{ color: '#fff' }}>311 215 22 00</Text>
                <br />
                <br />
                <Text strong style={{ color: '#fff' }}>Domicilio</Text>
                <br />
                <Text style={{ color: '#fff' }}>
                  AV. MEXICO SIN NUMERO, COL. CENTRO, TEPIC, NAYARIT C.P. 63000.
                </Text>
              </div>
            </Col>
          </Row>
          <br />
          <br />
          <Button
            $accent
            onClick={async () => {
              await showOrder();
              setVisibleInstrucciones(false);
            }}
            $block
          >
            <Text>Generar orden de transferencia interbancaria</Text>
            <BarcodeOutlined />
          </Button>
        </Spin>
      </Modal>
      <Col span={0}>
        <form method="post" action={url} target="_top" ref={formRef} />
      </Col>
    </>
  );
};

export default ModalBancos;

ModalBancos.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  cargosGenerados: PropTypes.array,
  padron: PropTypes.object,
  currentClassifier: PropTypes.string,
  tipoDePadron: PropTypes.number,
  padrones: PropTypes.array,
  cbReferenciaBanco: PropTypes.func.isRequired,
  isNewFolio: PropTypes.bool,
  totalProp: PropTypes.string,
  periodoFiscal: PropTypes.string,
  folio: PropTypes.string,
};

ModalBancos.defaultProps = {
  onCancel: null,
  cargosGenerados: [],
  padron: [],
  currentClassifier: '',
  tipoDePadron: [],
  padrones: [],
  isNewFolio: false,
  totalProp: 'adeudo_total',
  periodoFiscal: null,
  folio: null,
};
